import styled from '@emotion/styled'

export const Wrapper = styled.div``

export const ErrorMessage = styled.div`
  color: #dc3545;
`
